module.exports = __webpack_public_path__ + "assets/826d836d145466eeb65630562dcee6bf.png";